<div
  #container
  [attr.data-pc-name]="'speeddial'"
  [attr.data-pc-section]="'root'"
  [class]="className"
  [ngClass]="containerClass()"
  [ngStyle]="style">
  <button
    class="p-button-icon-only"
    pButton
    pRipple
    type="button"
    [attr.aria-controls]="id + '_list'"
    [attr.aria-expanded]="visible"
    [attr.aria-haspopup]="true"
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabelledBy"
    [attr.data-pc-name]="'button'"
    [disabled]="disabled"
    [icon]="buttonIconClass"
    [ngClass]="buttonClass()"
    [style]="buttonStyle"
    (click)="onButtonClick($event)"
    (keydown)="onTogglerKeydown($event)">
    @if (!buttonTemplate) {
      @if (!showIcon) {
        <PlusIcon />
      }
    } @else {
      <ng-container [ngTemplateOutlet]="buttonTemplate" />
    }
  </button>
  <ul
    #list
    class="p-speeddial-list"
    role="menu"
    [attr.aria-activedescendant]="focused ? focusedOptionId : undefined"
    [attr.data-pc-section]="'menu'"
    [id]="id + '_list'"
    [tabindex]="-1"
    (focus)="onFocus($event)"
    (focusout)="onBlur($event)"
    (keydown)="onKeyDown($event)">
    @for (item of model; track i; let i = $index) {
      <li
        class="p-speeddial-item"
        pTooltip
        role="menuitem"
        [attr.aria-controls]="id + '_item'"
        [attr.data-pc-section]="'menuitem'"
        [id]="id + '_' + i"
        [ngClass]="{ 'p-hidden': item.visible === false, 'p-focus': focusedOptionId === id + '_' + i }"
        [ngStyle]="getItemStyle(i)"
        [tooltipOptions]="item.tooltipOptions">
        @if (_visible) {
          @if (isClickableRouterLink(item)) {
            <a
              class="p-speeddial-action"
              pRipple
              role="menuitem"
              [attr.aria-label]="item.label"
              [attr.data-pc-section]="'action'"
              [attr.tabindex]="item.disabled || !visible ? null : item.tabindex ? item.tabindex : '0'"
              [attr.target]="item.target"
              [fragment]="item.fragment"
              [ngClass]="{ 'p-disabled': item.disabled }"
              [preserveFragment]="item.preserveFragment"
              [queryParams]="item.queryParams"
              [queryParamsHandling]="item.queryParamsHandling"
              [replaceUrl]="item.replaceUrl"
              [routerLink]="item.routerLink"
              [skipLocationChange]="item.skipLocationChange"
              [state]="item.state"
              (click)="onItemClick($event, item)"
              (keydown.enter)="onItemClick($event, item)">
              @if (item.icon) {
                <span class="p-speeddial-action-icon" [ngClass]="item.icon"></span>
              }
            </a>
          } @else {
            <a
              class="p-speeddial-action"
              pRipple
              role="menuitem"
              [attr.aria-label]="item.label"
              [attr.data-pc-section]="'action'"
              [attr.href]="item.url || null"
              [attr.tabindex]="item.disabled || !visible ? null : item.tabindex ? item.tabindex : '0'"
              [attr.target]="item.target"
              [ngClass]="{ 'p-disabled': item.disabled }"
              (click)="onItemClick($event, item)"
              (keydown.enter)="onItemClick($event, item)">
              @if (item.icon) {
                <span class="p-speeddial-action-icon" [ngClass]="item.icon"></span>
              }
            </a>
          }
        }
      </li>
    }
  </ul>
</div>

@if (mask && visible) {
  <div
    [class]="maskClassName"
    [ngClass]="{ 'p-speeddial-mask': true, 'p-speeddial-mask-visible': visible }"
    [ngStyle]="maskStyle"></div>
}
